module.exports = __webpack_public_path__ + "static/media/ProductHideBlue.0db25890.svg";